module.exports = __webpack_public_path__ + "img/introduction-pic.30543eca.png";